import http from '../../http'

let list = (data) => {
  return http.post('opservice/tag/page', data)
}

let syslist = (data) => {
  return http.post('opservice/tag/sys/page?size=' + data.size + '&pageNum=' + data.pageNum, data)
}

let sysPersonlist = (data) => {
  return http.post('opservice/tag/sys/tag/listuser', data)
}

export default {
  list,
  syslist,
  sysPersonlist,
  get: (params) => {
    return http.get('opservice/tag/get', params)
  }, //根据ID查询用户标签
  save: (params) => {
    return http.post('opservice/tag/upsert', params)
  }, //保存或修改用户标签
  del: (params) => {
    return http.post('opservice/tag/delete', params)
  }, //删除用户标签(支持批量)
  tag: (params) => {
    return http.get('opservice/tag/list', params)
  }, //获取租户下标签
  property: (params) => {
    return http.get('opservice/tag/property', params)
  }, //获取用户标签筛选属性
  userlist: (params) => {
    return http.post('opservice/tag/listuser', params)
  } //根据ID查询用户
}
